<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>参展申请</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">参展申请</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="exportHandle">
          <span>新增活动</span>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent">
      <Table :border="false" row-key="id" :columns="columns" :data="list">
        <template slot-scope="{ row, index }" slot="name">{{ row.name }}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{
          row.showIndex
        }}</template>
        <template slot-scope="{ row, index }" slot="num">{{ row.regCount }}</template>
        <template slot-scope="{ row, index }" slot="type">{{
          row.type == "textArea" ? "富文本" : "链接"
        }}</template>

        <template slot-scope="{ row, index }" slot="button">
          <span style="color: #2357CD; cursor: pointer" @click="detailHandel(row)"
            >查看名单</span
          >
          <span style="display: inline-block; padding: 0 5px">|</span>
          <span style="color: #2357CD; cursor: pointer" @click="editHandel(row)"
            >编辑</span
          >
          <span style="display: inline-block; padding: 0 5px">|</span>
          <Poptip confirm title="确定删除吗？" @on-ok="review(row)" :transfer="true">
            <span style="color: #f00; cursor: pointer">删除</span>
          </Poptip>
        </template>
      </Table>
      <div
        class="my-page"
        v-if="totalCount > pageSize"
        style="margin: 20px; text-align: center"
      >
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </div>
    <iModal
      :title="titleModel"
      v-model="showModal"
      class-name="common-ad-add"
      width="900px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="120"
            @submit.native.prevent
          >
            <FormItem label="活动名称：" prop="name">
              <Input v-model="formInline.name" placeholder="请输入" />
            </FormItem>
            <!-- <FormItem label="banner：" required>
              <div class="my-upload">
                <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index">
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="2048" :headers="formHeaders"
                  :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="uploadUrl" style="display: inline-block;"
                  v-show="uploadList && uploadList.length < 1">
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传图片</p>
                    </div>
                  </div>
                </Upload>
                <iModal title="图片查看" cancel-text v-model="visible">
                  <div style="text-align: center;">
                    <img :src="imgName" v-if="visible" style="max-width: 100%" />
                  </div>
                </iModal>
              </div>
              <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png )</p>
            </FormItem> -->
            <FormItem label="活动方式：" prop="skipType">
              <Select v-model="formInline.skipType" style="width: 200px">
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>

            <FormItem
              label="活动内容："
              prop=""
              v-show="formInline.skipType === 'textArea'"
            >
              <div ref="editorElement"></div>
            </FormItem>

            <FormItem label="链接地址：" prop="" v-show="formInline.skipType === 'url'">
              <Input v-model="formInline.url" />
            </FormItem>

            <FormItem label="显示顺序：" prop="">
              <InputNumber
                :max="9999"
                :min="0"
                v-model="formInline.showIndex"
              ></InputNumber>
              <p style="font-size: 12px">（数字越大显示越靠前）</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          v-if="titleModel == '新增活动'"
          :loading="loading"
          @click="handleSubmit('formInline')"
          >确定</Button
        >
        <Button
          type="primary"
          v-if="titleModel == '编辑活动'"
          :loading="loading"
          @click="handleEdit('formInline')"
          >确定</Button
        >
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import wangeditor from "wangeditor";
import config from "@assets/config.json";

import axios from "axios";

export default {
  name: "common-banner-add",
  data() {
    return {
      uploadUrl: `${config.api.reqApi}/api/upload/files`,
      type: "firstPage",
      show: true,
      titleModel: "新增活动",
      loading: false,
      showModal: false,
      formInline: {
        id:'',
        name: "",
        showIndex: 0,
        skipType: "",
        content: "",
        url: "",
      },
      ruleInline: {
        name: [{ required: true, message: "请输入", trigger: "change" }],
        skipType: [{ required: true, message: "请选择", trigger: "change" }],
        showIndex: [{ required: true, message: "请输入", trigger: "change" }],
        content: [{ required: true, message: "请输入", trigger: "change" }],
        url: [{ required: true, message: "请输入", trigger: "change" }],
      },
      uploadList: [],
      defaultList: [],
      imgName: "",
      visible: false,
      typeList: [
        { value: "url", label: "外链" },
        { value: "textArea", label: "图文" },
      ],
      columns: [
        {
          title: "活动名称",
          key: "name",
          slot: "name",
        },
        {
          title: "显示顺序",
          key: "showIndex",
          slot: "showIndex",
        },
        {
          title: "报名数",
          key: "num",
          slot: "num",
        },
        {
          title: "活动类型",
          key: "type",
          slot: "type",
        },

        {
          title: "操作",
          key: "button",
          slot: "button",
        },
      ],
      list: [],
      pageIndex: 1,
      pageSize: 999,
      totalCount: 0,
      fileId: "",
    };
  },
  //   watch: {
  //     show (val, oldVal) {
  //       this.showModal = val;
  //       if (!val) this.$emit("close");
  //     }
  //   },
  computed: {
    ...mapGetters({
      uploadUrl2: "getUploadUrl2",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    option() {
      return {
        exhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        Wheres:''
        // Wheres: {
        //   type: 0,
        //   wheres: {
        //     WhereGroupOperator: 0,
        //     Predicates: [
        //       {
        //         type: 1,
        //         wheres: {
        //           WhereOperator: 6,
        //           Label: "",
        //           Value: "",
        //         },
        //       },
        //     ],
        //   },
        // },
      };
    },
  },
  mounted() {
    this.initEditor();
    this.init();
  },
  methods: {
    ...mapActions({
      PCActivityAdd: "hostSetModule/PCActivityAdd",
      PCActivityPage: "hostSetModule/PCActivityPage",
      PCActivityPut: "hostSetModule/PCActivityPut",
      delPCActivity: "hostSetModule/delPCActivity",
    }),
    async initEditor() {
      this.editor = new wangeditor(this.$refs.editorElement);
      this.editor.customConfig.zIndex = 1;
      // 赋值
      this.editor.customConfig.onchange = (e) => {
        this.formInline.content = e;
      };

      // 上传图片配置
      const that = this;
      this.editor.customConfig.customUploadImg = function (files, insert) {
        files.forEach((item) => {
          let fd = new FormData();
          fd.append("file", item); // 上传的文件： 键名，键值
          axios
            .post(`${config.api.reqApi}/api/upload/images`, fd)
            .then((data) => {
              if (data.data.successed) {
                insert(data.data.list[0]);
              } else {
                that.$Message.error("上传失败，请重试！");
              }
            })
            .catch((err) => {
              that.$Message.error("上传失败，请重试！");
              console.log(err.response.data);
            });
        });
      };

      this.editor.customConfig.menus = [
        // 菜单配置
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];
      this.editor.create(); // 创建富文本实例
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let form = this.formInline;
      //   if (this.uploadList.length == 0) {
      //     this.$Message.warning("请上传图片");
      //     return;
      //   }
      //   let imgList = this.transfromImgList(this.uploadList);
      let req = {
        exhibitionId: this.exhibitionInfo.id,
        name: form.name,
        type: form.skipType,
        content: form.content,
        url: form.url,
        showIndex: form.showIndex,
      };
      this.loading = true;
      let bool = await this.PCActivityAdd(req).catch((err) => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.cancel();
        this.init();
        this.loading = false;
        this.$Message.success("操作成功！");
      }
    },
    async handleEdit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let form = this.formInline;
      let req = {
        id: form.id,
        setValues: {
          Name: form.name,
          Type: form.skipType,
          Content: form.content,
          Url: form.url,
          ShowIndex: form.showIndex,
        },
      };
      this.loading = true;
      let bool = await this.PCActivityPut(req).catch((err) => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.cancel();
        this.init();
        this.loading = false;
        this.$Message.success("操作成功！");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach((c) => {
        arr2.push(c.url);
      });
      return arr2;
    },
    cancel() {
      this.formInline.link = "";
      this.formInline.showIndex = 0;
      this.uploadList = [];
      //   this.$refs.upload.fileList = [];
      this.$refs["formInline"].resetFields();
      this.showModal = false;
    },

    async init() {
      let list = await this.PCActivityPage(this.option);
      if (list && list.items.length > 0) {
        this.list = list.items;
      } else {
        this.list = [];
      }
      this.pageIndex = list.pageIndex;
      this.pageSize = list.pageSize;
      this.totalCount = list.totalCount;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    async review(e) {
     console.log(e);
      let bool = await this.delPCActivity(
       e.id
      );
      if (bool && bool.successed) {
        this.$Message.success({
          content: "操作成功",
        });
      } else {
        this.$Message.success("操作失败，请重试！");
      }
      this.init();
    },
    async exportHandle() {
      this.titleModel = "新增活动";
      this.showModal = true;
      return;
      let opt = {
        pageIndex: 1,
        pageSize: 2000,
      };
      let res = await this.excelExportLog(opt);
      if (res) {
        const aLink = document.createElement("a");
        let blob = new Blob([res], {
          type: "application/vnd.ms-excel",
        });
        aLink.href = URL.createObjectURL(blob);
        aLink.setAttribute("download", "参展申请" + ".xlsx"); // 设置下载文件名称
        document.body.appendChild(aLink);
        aLink.click();
      }
    },
    async editHandel(e) {
      this.titleModel = "编辑活动";
      this.formInline.id = e.id;
      this.formInline.name = e.name;
      this.formInline.skipType = e.type;
      this.formInline.content = e.content;
      this.formInline.url = e.url;
      this.formInline.showIndex = e.showIndex;
      this.editor.txt.html(e.content);
      this.showModal = true;
      console.log(e);
    },

    detailHandel(e){
        this.$router.push({ path: '/host/index/ex/activityDetail', query: { id:e.id ,activityName:e.name} });
    },
  },
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.common-ad-add {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

.disabled {
  &.ivu-btn.ivu-btn-default:hover,
  &.ivu-btn.ivu-btn-default:focus,
  &.ivu-btn.ivu-btn-default:active,
  &.ivu-btn.ivu-btn-default:visited {
    color: inherit;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .common-ad-add {
    display: block;

    .ivu-modal {
      top: 150px;
    }
  }
}
</style>
